module.exports = __webpack_public_path__ + "media/assets/img/main-bg-be24b2db6caae5f1b62d3a40563f8184.jpg";